<template>
  <component :is="component" v-bind="componentProps" v-on="componentEvents" />
</template>

<script>
import Confirmable from '../mixins/confirmable'
import Actionable from '../mixins/actionable'

export default {
  name: 'DialogServiceBody',

  mixins: [Confirmable],

  layout: ['default'],

  props: {
    actionOptions: {
      type: Object,
      default: () => ({}),
    },
    text: {
      type: [String, Function],
      default: '',
    },
    headerDivider: {
      type: Boolean,
      default: true,
    },
    actionsDivider: {
      type: Boolean,
      default: true,
    },
    actionsOverride: {
      type: Object,
      default: () => ({}),
    },

    component: {
      type: Object,
      default: null,
    },
    componentProps: {
      type: Object,
      default: () => ({}),
    },
    componentEvents: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
